// extracted by mini-css-extract-plugin
module.exports = {"btn":"email-verify_btn__W7iEu","verify-btn":"email-verify_verify-btn___fcBX","verify-btn-disabled":"email-verify_verify-btn-disabled__yPp0S"};